import { Helmet } from "react-helmet";
import { NavLink } from "react-router-dom";
import Breadcrumbs from "../components/Breadcrumbs/Breadcrumbs";
import Wrapper from "../components/Wrapper/Wrapper";

import styles from "./Search.module.css";

const Search = () => {

    return (
        <Wrapper background="rgb(240, 240, 240)">
            <Helmet>
                <title>Vyhledávání</title>
            </Helmet>
            <Breadcrumbs />
            <h2 className={styles.headingTop}>Vyhledávání</h2>
            <div className={styles.buttonWrapper}>
                <NavLink className={styles.button} to="/vyhledavani/rrzj">
                    Vyhledávání v referenčním rámci
                </NavLink>
                {/* <NavLink className={styles.button} to="/vyhledavani/popisy">
                    Vyhledávání v popisech
                </NavLink> */}
            </div>
        </Wrapper>
    );

}

export default Search;